'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useNavDrawerFooter_unstable", {
    enumerable: true,
    get: function() {
        return useNavDrawerFooter_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactdrawer = require("@fluentui/react-drawer");
const useNavDrawerFooter_unstable = (props, ref)=>{
    return (0, _reactdrawer.useDrawerFooter_unstable)(props, ref);
};
